import { CircularProgress, FormHelperText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { find } from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormControl } from './index';
import { Typography } from '@mui/material';
import { ListItemText, Stack } from 'node_modules/@mui/material/index';

const OptionMultiListAutoComplete = (props) => {
  const {
    variant,
    inputValue,
    onBlur,
    selectOption,
    onInputChange,
    getOptionLabel,
    getOptionValue,
    onChange,
    name,
    label,
    value,
    required,
    fullWidth,
    helperText,
    disabled,
    options,
    loading,
    starReq,
    isImage,
    isString,
    isDescription,
    isSubLabel,
    isLabelType,
  } = props;
  const [optionsData, setOptionData] = React.useState([]);
  const [option, setOption] = React.useState([]);

  const getLabel = React.useCallback(
    (element) => {
      if (element && element[getOptionLabel]) {
        return element[getOptionLabel];
      } else {
        return '';
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [getOptionLabel]
  );

  const getValue = React.useCallback((element) => {
    if (element && element[getOptionValue]) {
      return element[getOptionValue];
    } else {
      return '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let optionsData = [];
    if (options) {
      options.map((element) => {
        if (getLabel(element)) {
          optionsData.push({
            label: getLabel(element),
            value: getValue(element),
            ...(isSubLabel && { description: element?.description }),
            ...(isLabelType && { skill_type: element?.skill_type?.name }),
          });
        }
      });
    }
    setOptionData(optionsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  React.useEffect(() => {
    const defaultValue = find(optionsData, { value: isString ? value : Number(value) });
    if (defaultValue) {
      setOption(defaultValue);
    } else if (selectOption) {
      const defaultOption = {
        label: getLabel(selectOption),
        value: getLabel(selectOption),
      };
      setOption(defaultOption);
    } else {
      setOption(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, selectOption, optionsData]);

  return (
    <FormControl key={`key${name}`} error={helperText ? true : false} fullWidth={fullWidth} required={required}>
      <Autocomplete
        disabled={disabled}
        options={optionsData}
        onBlur={onBlur}
        value={option}
        inputValue={inputValue}
        variant={variant}
        onInputChange={(event, newValue) => {
          if (event?.type === 'change') {
            onInputChange(newValue || '');
          } else {
            onInputChange(null);
          }
        }}
        getOptionLabel={(option) => option.label || ''} //MUI warning issue fixed by this code in autoComplete
        autoHighlight
        loading={loading}
        onChange={(event, newValue) => {
          if (event?.type === 'click') {
            onChange(newValue?.value || '');
          } else {
            onChange(null);
          }
        }}
        renderOption={(props, option) => (
          <Box key={`${name}-option-${option.value}`} component="li" {...props}>
            <ListItemText
              primary={
                <Stack spacing={0.2}>
                  <Typography component="p" variant="caption">
                    {option?.skill_type}
                  </Typography>
                  <Typography component="p" variant="subtitle1">
                    {option?.label}
                  </Typography>
                </Stack>
              }
              secondary={option?.description}
            />
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            error={helperText ? true : false}
            {...params}
            label={label}
            variant={variant}
            required={starReq}
            InputProps={{
              ...params.InputProps,
              autoComplete: 'off', // disable autocomplete and autofill
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

OptionMultiListAutoComplete.defaultProps = {
  fullWidth: true,
  required: false,
  disabled: false,
  loading: false,
  variant: 'outlined',
  options: [],
  value: null,
  label: 'name',
  onChange: () => { },
  onInputChange: () => { },
  onBlur: () => { },
  selectOption: {},
};

OptionMultiListAutoComplete.propTypes = {
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  loading: PropTypes.bool,
  inputValue: PropTypes.string,
  getOptionLabel: PropTypes.string,
  getOptionValue: PropTypes.string,
  variant: PropTypes.string,
  selectOption: PropTypes.object,
  starReq: PropTypes.string,
  isImage: PropTypes.bool,
  isString: PropTypes.bool,
  isDescription: PropTypes.bool,
  isSubLabel: PropTypes.bool,
  isLabelType: PropTypes.bool,
};

export default OptionMultiListAutoComplete;
